import { render, staticRenderFns } from "./editTag.vue?vue&type=template&id=293f1ef1&scoped=true"
import script from "./editTag.vue?vue&type=script&lang=js"
export * from "./editTag.vue?vue&type=script&lang=js"
import style0 from "./editTag.vue?vue&type=style&index=0&id=293f1ef1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293f1ef1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('293f1ef1')) {
      api.createRecord('293f1ef1', component.options)
    } else {
      api.reload('293f1ef1', component.options)
    }
    module.hot.accept("./editTag.vue?vue&type=template&id=293f1ef1&scoped=true", function () {
      api.rerender('293f1ef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/tag/editTag.vue"
export default component.exports